var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-SingleMedia"},[_c('c-topbar-title',[_c('h1',{staticClass:"sr-only"},[_vm._v("Title")])]),_c(_vm.viewByType,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }